<template>
  <van-popup v-model="popupShow" position="center">
    <div class="popup-soc-content">
      <div class="popup-title">设定SOC</div>
      <div class="soc-slider">
        <div class="slider-number">
          <div class="slider-number-flex left" :class="{'main-color':value == floorSoc }">{{floorSoc}}％</div>
          <div class="slider-number-flex right" :class="{'main-color':value == defaultSoc}">{{defaultSoc}}％</div>
        </div>
        <div class="slider-bg-box">
          <div class="slider-bg">
            <div class="slider-bg-start"></div>
            <div class="slider-bg-scale n1"></div>
            <div class="slider-bg-scale n2"></div>
            <div class="slider-bg-scale n3"></div>
            <div class="slider-bg-scale n4"></div>
            <div class="slider-text" :style="{left: getBai(value)}" v-show="value > floorSoc && value< (defaultSoc)">{{value}}%</div>
            <van-slider active-color="#14CC80" inactive-color="#91FFD2" v-model="value" :min="floorSoc" :max="defaultSoc" />
          </div>
          
        </div>
      </div>
      <div class="popup-tips">
        <p>soc达到设定值后将自动结束充电，仅适合用于直流桩</p>
      </div>
      <div class="popup-btn">
        <div class="popup-btn-flex confirm" @click="confirm">确定</div>
        <div class="popup-btn-flex" @click="popupShow = false;">取消</div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import {  Popup, Slider } from "vant";
export default {
  name: 'pi-select-soc',
  components: {
    [Popup.name]: Popup,
    [Slider.name]: Slider,
  },
  data(){
    return {
      popupShow: false,
      value: 50,
    }
  },
  methods: {
    open(){
      this.popupShow = true;
    },
    getBai(value){
      let val = value - this.floorSoc;
      let total = this.defaultSoc - this.floorSoc;
      let num = val / total * 100;
      return num + '%';
    },
    confirm(){
      this.popupShow = false;
      this.$emit('change',this.value)
    }
  },
  watch: {
    soc: function(val){
      this.value = val;
    }
  },
  props: {
    soc: {
      type:Number,
      default: 50
    },
    floorSoc: {
      type:Number,
      default: 50
    },
    defaultSoc: {
      type:Number,
      default: 100
    }
  }
}
</script>
<style lang="less">
  .popup-soc-content{
    width: 7.1rem;
    background:#fff;
    border-radius:0.1rem;
    .popup-title{
      padding: 0.3rem;
      text-align: center;
      font-size: 0.36rem;
      line-height: 0.42rem;
    }
    .soc-slider{
      box-shadow:0px 1px 6px 0px rgba(192,192,192,0.5);
      border-radius:0.05rem;
      margin: 0 0.13rem;
      padding: 0.18rem 0;
      
      .slider-number{
        display: flex;
        font-size: 0.24rem;
        color: #333;
        line-height: 0.31rem;
        .slider-number-flex{
          flex: 1;
        }
        .right{
          text-align: right;
        }
        .left{
          padding-left: 0.21rem;
        }
      }
      .slider-bg-box{
        padding: 0.1rem 0;
        margin: 0.18rem 0.42rem 0 0.31rem;
      }
      .slider-bg{
        height: 0.06rem;
        background-color: #91FFD2;
        position: relative;
        .slider-bg-start{
          width:  0.26rem;
          height:  0.26rem;
          border-radius: 50%;
          background-color: #14CC80;
          position:absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -50%;
        }
        .slider-bg-scale{
          width: 0.06rem;
          height: 0.11rem;
          position: absolute;
          bottom: 100%;
          background-color: #91FFD2;
          transform: translateX(-100%);
        }
        .slider-bg-scale.n1{
          left: 25%;
        }
        .slider-bg-scale.n2{
          left: 50%;
        }
        .slider-bg-scale.n3{
          left: 75%;
        }
        .slider-bg-scale.n4{
          left: 100%;
        }
        .van-slider{
          z-index: 5;
        }
      }
    }
    .popup-tips{
      margin-top: 0.4rem;
      font-size: 0.24rem;
      line-height: 0.38rem;
      color: #FFA244;
      text-align: center;
    }
    .popup-btn{
      display: flex;
      margin-top: 0.4rem;
      border-top: 0.01rem solid #EEEEEE;
      padding: 0.12rem 0;
      text-align: center;
      font-size: 0.34rem;
      line-height: 0.48rem;
      color: #999999;
      .popup-btn-flex{
        flex: 1;
        line-height: 0.7rem;
      }
      .confirm{
        color: #14CC80;
        border-right: 0.01rem solid #EEEEEE;
      }
    }
    .van-slider__button{
      width: 0.26rem;
      height: 0.26rem;
      background-color: #14CC80;
    }
    .slider-text{
      font-size: 0.24rem;
      line-height: 0.31rem;
      color:#14CC80;
      position: absolute;
      top: -0.58rem;
      transform: translateX(-50%);
    }
  }
</style>